import * as t from 'io-ts';

import {TwoDimensionalMap} from '../../helpers/dataStructures/twoDimensionalMap';
import {AppState} from '../../store/appState';
import {GetShouldPersist, ResourceMapAffinitiesEnum, ResourceMapType} from '../../store/appTypes';
import {RemovalCandidatesTree} from './gcDataStructures';

/*
 * Types.
 */

export interface ReachableChild {
  obj: unknown;
  type: t.Type<any>;
  path: ReadonlyArray<string>;
  isTransient: boolean;
}

export enum GarbageCollectorStagesEnum {
  INITIALIZING,
  SEARCHING,
  CLEANING,
  FINISHED,
}
export interface ResourceMapDefinition {
  path: ReadonlyArray<string>;
  type: ResourceMapType<any, any>;
  initialAffinity: ResourceMapAffinitiesEnum;
  getShouldPersist: GetShouldPersist<any>;
}

export interface GarbageCollectorInitializingState {
  stage: GarbageCollectorStagesEnum.INITIALIZING;
}

export interface GarbageCollectorSearchingState {
  stage: GarbageCollectorStagesEnum.SEARCHING;
  mapDefinitions: ReadonlyArray<ResourceMapDefinition>;
  removalCandidates: RemovalCandidatesTree;
  // Allow this array to be mutable for performance reasons.
  unscannedItems: Array<ReachableChild>;
  scannedItems: TwoDimensionalMap<any, t.Type<any>>;
  lastScannedState: AppState;
}

export interface GarbageCollectorCleaningState {
  stage: GarbageCollectorStagesEnum.CLEANING;
  mapDefinitions: ReadonlyArray<ResourceMapDefinition>;
  removalCandidates: RemovalCandidatesTree;
}

export interface GarbageCollectorFinishedState {
  stage: GarbageCollectorStagesEnum.FINISHED;
  newState: AppState;
}

export type GarbageCollectorState =
  | GarbageCollectorInitializingState
  | GarbageCollectorSearchingState
  | GarbageCollectorCleaningState
  | GarbageCollectorFinishedState;

export function isInitializingState(
  state: GarbageCollectorState,
): state is GarbageCollectorInitializingState {
  return state.stage === GarbageCollectorStagesEnum.INITIALIZING;
}

export function isFinishedState(state: GarbageCollectorState): state is GarbageCollectorFinishedState {
  return state.stage === GarbageCollectorStagesEnum.FINISHED;
}
